import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const select = async (data: any) => httpRequest.get("/inv/client_classification/select", data);
